import { alignments, optionLabelPositions } from './displayOptions';
import { labelSizes } from '../commonDisplayOptions';
import { fieldNames } from '../fields';

export const dataModel = {
    component: String(),
    id: String(),
    label: String(),
    labelSize: labelSizes,
    options: [],
    alignment: String(),
    optionLabelPosition: String(),
    reportingLabel: String(),
    helperText: String(),
    value: String(),
    required: Boolean()
};

export const defaults = {
    component: fieldNames.checkbox,
    labelSize: labelSizes.sm.value,
    alignment: alignments.vertical.value,
    optionLabelPosition: optionLabelPositions.right.value
};
